module.exports = __webpack_public_path__ + "img/RegenInBergen.94f6f1e7.svg";